export default "__VITE_PUBLIC_ASSET__2c0005ab__"